import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const BotonAtras = ({ onClick }) => (
  <Button
    onClick={onClick}
    style={{ padding: "0px 3px 0px 3px", marginTop: "1%" }}
    color="secondary"
  >
    <ArrowBackIcon />
    <Typography variant="body2" style={{ color: "#9e9e9e" }} component="p">
      Atras
    </Typography>
  </Button>
);

BotonAtras.propTypes = { onClick: PropTypes.func.isRequired };

export default BotonAtras;
